<template>
  <div class="app-container">
    <div>
      <el-tabs v-model="activeName" @tab-click="handleClicktab" style="margin: 0;">
        <el-tab-pane label="待确认" name="first">
          <div class="formBox margbot" ref="searchBox">
            <el-form :inline="true" :model="formData" label-width="90px" size="mini">
              <div class="formItemBox">
                <el-form-item label="转货单号:">
                  <el-input v-model="formData.changeNo" placeholder="请输入"></el-input>
                </el-form-item>
                <el-form-item label="转货时间:" >
                  <div style="display: flex;">
                    <el-date-picker v-model="formData.createTimeStart" size="mini" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    -
                    <el-date-picker v-model="formData.createTimeEnd" size="mini" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="原一级货主:">
                  <el-select filterable clearable placeholder="请选择" v-model="formData.oldPriCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="原二级货主:">
                  <el-select clearable filterable placeholder="请选择" v-model="formData.oldCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现一级货主:">
                  <el-select filterable clearable placeholder="请选择" v-model="formData.newPriCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现二级货主:">
                  <el-select clearable filterable placeholder="请选择" v-model="formData.newCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="货物类型:">
                  <el-select v-model="formData.productType" clearable placeholder="请选择" filterable>
                    <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
                    </el-option>
                  </el-select>
                </el-form-item>
              </div>
              <!-- <el-form-item label="数据来源:">
                <el-select
                v-model="formData.source"
                size="mini"
                placeholder="请选择数据来源"
                clearable
                >
                <el-option
                v-for="item in SjData"
                :key="item.item_no"
                :label="item.show_name"
                :value="item.item_no"
                ></el-option>
                </el-select>
              </el-form-item> -->
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxun" btnCode="00ZP006B001" v-if="btnFlg[0]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhi" btnCode="00ZP006B002" v-if="btnFlg[1]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochu" btnCode="00ZP006B003" v-if="btnFlg[2]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="chexiao" btnCode="00ZP006B004" v-if="btnFlg[3]">撤销分货
                </el-button>
                <el-button type="primary" size="mini" @click="ercifenhuo" btnCode="00ZP006B005" v-if="btnFlg[4]">二次分货
                </el-button>
                <el-button type="primary" size="mini" @click="xiugai" btnCode="00ZP006B006" v-if="btnFlg[5]">修改客户
                </el-button>
                <el-button type="primary" size="mini" @click="QRjincang" btnCode="00ZP006B007" v-if="btnFlg[6]">进仓确认
                </el-button>
              </el-form-item>
              <div style="padding-bottom: 5px;"><span>总吨数<span style="color:red;">{{Number(totalWeight)}}</span>吨</span><span style="margin-left:10px;">总件数<span style="color:red;">{{totalNumber}}</span>件</span></div>
            </el-form>
          </div>
          <div :style="{height:h}">
            <el-table border center bordersize="mini" :data="tableData" height="100%" style="width:100%" size="mini" highlight-current-row :header-cell-style="{ background: '#F5F5F5', color: 'black' }" @selection-change="selectGoods" class="tableComent">
              <el-table-column type="selection" align="center" width="60"></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createTime" label="转货时间" width="190">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="changeNo" label="转货单号" width="250"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="oldPriCustomerName" label="原一级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="oldCustomerName" label="原二级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="newPriCustomerName" label="现一级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="newCustomerName" label="现二级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="70"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量（吨）" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重（吨）" width="120"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重（吨）" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="净重过磅时间" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createUser" label="操作人" width="120">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChange" :current-page="pageNo" :page-size="pageSize" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange" :total="total"></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="已确认" name="second">
          <div class="formBox margbot" ref="searchBoxT">
            <el-form :inline="true" :model="formDataTwo" label-width="90px" size="mini">
              <div class="formItemBox">
                <el-form-item label="转货单号:">
                  <el-input  v-model="formDataTwo.changeNo" placeholder="请输入转货单号"></el-input>
                </el-form-item>
                <el-form-item label="进仓单号:">
                  <el-input v-model="formDataTwo.distributionInNo" placeholder="请输入进仓单号"></el-input>
                </el-form-item>
                <el-form-item label="确认时间:" >
                  <div style="display: flex;">
                    <el-date-picker v-model="formDataTwo.confirmTimeStart" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    -
                    <el-date-picker v-model="formDataTwo.confirmTimeEnd" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </div>
                </el-form-item>
                <el-form-item label="原一级货主:">
                  <el-select filterable clearable placeholder="请选择" v-model="formDataTwo.oldPriCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="原二级货主:">
                  <el-select clearable filterable placeholder="请选择" v-model="formDataTwo.oldCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现一级货主:">
                  <el-select filterable clearable placeholder="请选择" v-model="formDataTwo.newPriCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="现二级货主:">
                  <el-select clearable filterable placeholder="请选择" v-model="formDataTwo.newCustomerTaxId">
                    <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="货物类型:">
                  <el-select v-model="formDataTwo.productType" clearable placeholder="请选择" filterable>
                    <el-option v-for="(item, index) in productTypeData" :key="index" :label="item.productTypeName" :value="item.productType">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="转货时间:" >
                  <div style="display: flex;">
                    <el-date-picker v-model="formDataTwo.createTimeStart" size="mini" type="datetime" placeholder="请选择" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                    -
                    <el-date-picker v-model="formDataTwo.createTimeEnd" size="mini" placeholder="请选择" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                  </div>
                </el-form-item>
              </div>
              <!-- <el-form-item label="进仓单号:">
              <el-input
                class="ipt"
                v-model="formDataTwo.inWarehouseNo"
                placeholder="请输入进仓单号"
                size="mini"
                style="width: 150px"
              ></el-input>
            </el-form-item> -->
              <el-form-item>
                <el-button type="primary" size="mini" @click="chaxunT" btnCode="00ZP006B008" v-if="btnFlg[7]">查询
                </el-button>
                <el-button type="primary" size="mini" @click="chongzhiT" btnCode="00ZP006B009" v-if="btnFlg[8]">重置
                </el-button>
                <el-button type="primary" size="mini" @click="daochuT" btnCode="00ZP006B00A" v-if="btnFlg[9]">导出
                </el-button>
                <el-button type="primary" size="mini" @click="xiugaiT" btnCode="00ZP006B00B" v-if="btnFlg[10]">修改进仓单
                </el-button>
                <el-button type="primary" size="mini" @click="chexiaoT" btnCode="00ZP006B00C" v-if="btnFlg[11]">撤销
                </el-button>
              </el-form-item>
              <div style="padding-bottom:5px ;"><span>总吨数<span style="color:red;">{{Number(totalWeight)}}</span>吨</span><span style="margin-left:10px;">总件数<span style="color:red;">{{totalNumber}}</span>件</span></div>
            </el-form>
          </div>
          <div :style="{height:H}">
            <el-table border center bordersize="mini" :data="tableDataT" height="100%" style="width:100%" size="mini" @selection-change="selectGoods" class="tableComent">
              <el-table-column type="selection" align="center" width="60"></el-table-column>
              <el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
              <el-table-column width="100" label="操作" align="center">
                <template v-slot='scope'>
                  <el-button type="text" @click="editRecord(scope.$index,scope.row)">修改记录</el-button>
                </template>
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="createTime" label="转货时间" width="190">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="distributionInNo" label="进仓单号" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="changeNo" label="转货单号" width="250"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" align="center" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="oldPriCustomerName" label="原一级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="oldCustomerName" label="原二级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="newPriCustomerName" label="现一级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="newCustomerName" label="现二级货主" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="steelMillName" label="产地" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="100">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="model" label="材质" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="100"></el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量(吨)" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="weight" label="理重(吨)" width="120">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeight" label="过磅净重(吨)" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="poundWeightTime" label="净重过磅时间" width="220">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="confirmName" label="确认人" width="150">
              </el-table-column>
              <el-table-column :show-overflow-tooltip="true" prop="confirmTime" label="确认时间" width="220">
              </el-table-column>
            </el-table>
          </div>
          <div class="pags">
            <el-pagination background @current-change="handleCurrentChangeT" :current-page="pageNoT" :page-size="pageSizeT" :page-sizes="[10,20,30,40,50]" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChangeT" :total="totalT"></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- 进仓确认 -->
    <div>
      <el-dialog title="进仓确认" :visible.sync="dialogVisiblejincang" :close-on-click-modal="false" @close="dialogVisiblejincang=false" :width="jinCangWidth" center :class="[checked?'activeTwo':'activeOne']">
        <!--form表单-->
        <el-form :model="xiugaiFormData" ref="xiugaiFormData" :inline="true">
          <el-form-item prop="distributionInNo" label="进仓单号" :rules="[
              { required: true, message: '请输入进仓单号', trigger: 'blur' },
            ]">
            <el-input size="mini" v-model="xiugaiFormData.distributionInNo" style="width:193px;"></el-input>
          </el-form-item>
          <el-form-item v-if="rukuFee">
            <el-checkbox v-model="checked">收取入库费</el-checkbox>
          </el-form-item>
        </el-form>
        <el-table border center bordersize="mini" :data="tableDataQR" height="100%" style="width:100%" size="mini" v-if="checked">
          <el-table-column label="结算客户" width="250">
            <template slot-scope="scope">
              <el-select v-model="scope.row.payCustomerTaxId" placeholder="请选择" filterable size="mini" @change="payCustomer(scope.row.payCustomerTaxId,scope.row)">
                <el-option v-for="(item, index) in payCustomerData" :key="index" :label="item.showName" :value="item.itemNo">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="arrivalMethod" label="到货方式" width="120">
            <template slot-scope="scope">
              <el-select v-model="scope.row.arrivalMethod" placeholder="请选择" filterable size="mini" @change="changeArrival(scope.row.arrivalMethod,scope.row)">
                <el-option v-for="(item, index) in arrivalMethodData" :key="index" :label="item.show_name" :value="item.item_no">
                </el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="instockDate" label="入库日期" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="productTypeName" label="货物类型" width="100">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="specification" label="规格" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="number" label="件数" width="80"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="allWeight" label="总重量(吨)" width="120">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="unitPrice" label="单价（元/吨）" width="120"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="feeAmount" label="金额（元）" width="100"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="newPriCustomerName" label="现一级货主" width="250">
          </el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="newCustomerName" label="现二级货主" width="250">
          </el-table-column>
        </el-table>
        <div style="width:180px;margin:15px auto;">
          <el-button @click="dialogVisiblejincang = false">取 消</el-button>
          <el-button type="primary" @click="jincangQR()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!--点击二次分货出框-->
    <div class="addMarkBox" custom-class="el-dialog--center">
      <el-dialog :before-close="closeDialogEcfh" title="二次分货" :visible.sync="ecfhVisible" :close-on-click-modal="false" width="90%" center>
        <p>分货前信息</p>
        <el-table border bordersize="mini" size="mini" :data="fenhuoQian">
          <el-table-column prop="number" label="件数"></el-table-column>
          <el-table-column prop="allWeight" label="重量(吨)"></el-table-column>
          <el-table-column prop="instockDate" label="入库日期"></el-table-column>
          <el-table-column prop="newCustomerName" label="现二级货主" width="200px"></el-table-column>
          <el-table-column prop="productTypeName" label="货物类型" width="120px"></el-table-column>
          <el-table-column prop="steelMillName" label="产地"></el-table-column>
          <el-table-column prop="model" label="规格"></el-table-column>
          <el-table-column prop="specification" label="材质"></el-table-column>
        </el-table>
        <p>分货后信息 <el-button type="primary" @click="addFenHuo">新增</el-button>
        </p>
        <el-table border bordersize="mini" size="mini" :data="fenhuoHou" :header-cell-class-name="Add">
          <el-table-column prop="distributCustomerTaxId" label="二级货主" width="200px">
            <template v-slot='scoped'>
              <el-select v-model="scoped.row.distributCustomerTaxId" size="mini" placeholder="请选择货主" filterable clearable @change="HuozhuName(scoped.row)">
                <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="distributNumber" label="分货件数">
            <template v-slot='scoped'>
              <el-input v-model="scoped.row.distributNumber" placeholder="请输入" v-number-input.float='0' size="mini" @input="FhnumberInput(scoped.row)"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="lizhong" label="理重(吨)">
            <template v-slot='scoped'>
              <el-input v-model="scoped.row.lizhong" placeholder="请输入" :disabled='true' size="mini"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="poundWeight" label="磅重(吨)">
            <template v-slot='scoped'>
              <el-input v-model="scoped.row.poundWeight" v-number-input.float='3' placeholder="请输入" size="mini">
              </el-input>
            </template>
          </el-table-column>
          <el-table-column prop="number" label="操作">
            <template v-slot='scoped'>
              <el-button type="primary" size="mini" @click='shanchuFenhuo(scoped.$index,scoped.row)'>删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <div style="margin: 15px auto" class="el-dialog--center">
          <el-button @click="ecfhVisible = false">取消</el-button>
          <el-button type="primary" @click="erciFenhuoSave()" :disabled="isDisable1">确定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改客户 -->
    <div>
      <el-dialog title="修改客户" :visible.sync="XGvisible" :close-on-click-modal="false" @close="XGvisible=false" width="25%" center>
        <!--form表单-->
        <el-form @submit.native.prevent :model="KHFormData" ref="KHFormData" label-width="100px" class="demo-dynamic" style="width:350px;margin:30px auto;">
          <el-form-item prop="modifyBefore" label="原客户：">{{ oldcustomer }}</el-form-item>
          <el-form-item prop="modifyAfter" label="新客户：" :rules="[
              { required: true, message: '请选择新客户', trigger: 'change' },
            ]">
            <el-select size="mini" ref="selectProvinces" filterable clearable placeholder="请选择新客户" v-model="KHFormData.modifyAfter" @visible-change='isShowSelectOptions'>
              <el-option v-for="(item, index) in HZData" :key="index" :label="item.custerName" :value="item.taxpayerNumber">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div style="width:150px;margin:15px auto;">
          <el-button @click="XGvisible = false">取 消</el-button>
          <el-button type="primary" @click="XGQD()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改进仓单号 -->
    <div>
      <el-dialog title="修改进仓单号" :visible.sync="XGDHvisible" :close-on-click-modal="false" @close="XGDHvisible=false" width="50%" center>
        <!--form表单-->
        <el-form :model="DHFormData" ref="DHFormData" label-width="150px" class="demo-dynamic" style="width:350px;margin:30px auto;">
          <el-form-item prop="modifyBefore" label="原进仓单号：">{{ oldDH }}</el-form-item>
          <el-form-item prop="modifyAfter" label="新进仓单号：" :rules="[
              { required: true, message: '请选择进仓单号', trigger: 'change' },
            ]">
            <el-input size="mini" v-model="DHFormData.modifyAfter" style="width:193px;"></el-input>
          </el-form-item>
        </el-form>
        <div style="width:150px;margin:15px auto;">
          <el-button @click="XGDHvisible = false">取 消</el-button>
          <el-button type="primary" @click="XGDH()" :loading="addLoad">确 定</el-button>
        </div>
      </el-dialog>
    </div>
    <!-- 修改记录 -->
    <div>
      <el-dialog title="修改记录" :visible.sync="XGJLVisible" :close-on-click-modal="false" width="50%" center="" @close='closeXGJL'>
        <el-table height="300px" border bordersize="mini" size="mini" ref="tabref" :data="XGRecordData" style="width:100%" highlight-current-row :header-cell-style="{background:'#F5F5F5',color:'black'}">
          <el-table-column :show-overflow-tooltip="true" prop="modifyBefore" label="修改前"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="modifyAfter" label="修改后"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createUser" label="修改人"></el-table-column>
          <el-table-column :show-overflow-tooltip="true" prop="createTime" label="修改时间" :formatter='dateTimeFormat'>
          </el-table-column>
        </el-table>
        <div style="width: 180px; margin: 15px auto">
          <el-button @click="closeXGJL">关 闭</el-button>
          <!-- <el-button type="primary" @click="succeXGJL" :loading='XGJLLoading'>保 存</el-button> -->
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  JfgetStorkConfirmedlList,
  arrivalMethod
} from '@/api/wms-access'
import {
  getRelationCustomer,
  JfgetDistributionGoodsList,
  getVirtualBalingList,
  JfsecondDistributionGoods,
  JfrevokeDistributionGoods,
  JfconfirmDistributionGoods,
  getWeighingMethodList,
  JfmodifyDistributionGoods,
  JfgetDistributionGoodsNumber,
  JfgetDistributionedGoodsList,
  revokeConfirmDistributionGoods,
  getConfirmGoodsFeeList
} from '@/api/wms-stock'
import {
  getBtn
} from '@/utils/getButton'
import DonMessage from '@/utils/message'
import {
  dateTimeFormat
} from '@/utils/util'
import {
  exportExcel
} from '@/utils/fileDown.js'
import {
  getQueryCusterData // 客户
} from '@/api/platform-settlement'
export default {
  data () {
    return {
      DHFormData: {
        modifyAfter: '',
        modifyBefore: ''
      },
      productTypeData: [], // 货物类型
      KHFormData: {
        modifyAfter: '',
        modifyBefore: ''
      },
      xiugaiFormData: {
        distributionInNo: ''
      },
      dateTimeFormat: dateTimeFormat, // 列表时间格式化
      activeName: 'first',
      total: 0,
      totalT: 0,
      formData: {
        changeNo: '',
        oldPriCustomerTaxId: '',
        oldCustomerTaxId: '',
        newPriCustomerTaxId: '',
        newCustomerTaxId: '',
        productType: '',
        createTimeStart: '',
        createTimeEnd: ''

      },
      pageNo: 1,
      pageSize: 20,
      btnArr: [
        '00ZP006B001',
        '00ZP006B002',
        '00ZP006B003',
        '00ZP006B004',
        '00ZP006B005',
        '00ZP006B006',
        '00ZP006B007',
        '00ZP006B008',
        '00ZP006B009',
        '00ZP006B00A',
        '00ZP006B00B',
        '00ZP006B00C'
      ],
      btnFlg: [],
      formDataTwo: {
        changeNo: '',
        distributionInNo: '',
        oldPriCustomerTaxId: '',
        oldCustomerTaxId: '',
        newPriCustomerTaxId: '',
        newCustomerTaxId: '',
        productType: '',
        confirmTimeStart: '',
        confirmTimeEnd: '',
        createTimeStart: '',
        createTimeEnd: ''
      },
      pageNoT: 1,
      pageSizeT: 20,
      tableDataT: [],
      tableData: [],
      HZData: [],
      h: 500,
      H: 500,
      xuanzhongArr: [],
      ecfhVisible: false,
      dialogVisiblejincang: false,
      addLoad: false,
      isDisable1: false,
      XGvisible: false,
      XGDHvisible: false,
      selectListId: [],
      selectList: [],
      oldcustomer: '',
      oldDH: '',
      XGJLVisible: false,
      XGJLLoading: false,
      XGRecordData: [],
      fenhuoQian: [],
      fenhuoHou: [],
      SjData: [],
      totalWeight: 0,
      totalNumber: 0,
      checked: false,
      tableDataQR: [],
      arrivalMethodData: [],
      payCustomerData: [],
      rukuFee: false
    }
  },
  computed: {
    jinCangWidth () {
      return this.checked ? '80%' : this.rukuFee ? '40%' : '30%'
    }
  },
  methods: {
    // 结算客户改变
    payCustomer (val, row) {
      console.log(val, row, this.tableDataQR)
      row.payCustomerName = this.payCustomerData.filter(item => item.itemNo == val)[0].showName
      getConfirmGoodsFeeList({
        changeList: this.tableDataQR
      }).then(res => {
        console.log(res)
        this.tableDataQR = res
      })
        .catch(error => {
          this.message.error(error.message)
        })
    },
    changeArrival (val, row) {
      console.log(val)
      row.arrivalMethodName = this.arrivalMethodData.filter(item => item.item_no == val)[0].show_name
      getConfirmGoodsFeeList({
        changeList: this.tableDataQR
      }).then(res => {
        console.log(res)
        this.tableDataQR = res
      })
        .catch(error => {
          this.message.error(error.message)
        })
    },
    // 到货方式
    arrivalMethod () {
      arrivalMethod().then(res => {
        console.log(res)
        this.arrivalMethodData = res
      })
        .catch(error => {
          this.message.error(error.message)
        })
    },
    // 获取所属客户数据
    getQueryCusterData () {
      getQueryCusterData().then(res => {
        this.payCustomerData = res
      }).catch(err => {
        this.$message({
          message: err.message,
          type: 'error'
        })
      })
    },
    // 是否显示下拉框
    isShowSelectOptions (isShowSelectOptions) {
      if (!isShowSelectOptions) this.$refs.selectProvinces.blur()
    },
    // 小星星
    Add (obj) {
      if (obj.column.property == 'distributCustomerTaxId' || obj.column.property == 'distributNumber') {
        console.log(22)
        return 'star'
      }
      if (this.fenhuoQian[0].outWeighingMethod == 2) {
        if (obj.column.property == 'poundWeight') {
          return 'star'
        }
      }
    },
    shanchuFenhuo (index, row) {
      this.fenhuoHou.splice(index, 1)
    },
    // 下拉框
    getVirtualBalingList () {
      getVirtualBalingList()
        .then(res => {
          this.productTypeData = []
          var obj = {}
          for (var i = 0; i < res.length; i++) {
            if (!obj[res[i].productTypeName]) {
              this.productTypeData.push(res[i])
              obj[res[i].productTypeName] = true
            }
          }
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    // 总件数总吨数
    JfgetDistributionGoodsNumbers (index) {
      let param = index == 0 ? this.formData : this.formDataTwo
      let pageSize = index == 0 ? this.pageSize : this.pageSizeT
      let pageNo = index == 0 ? this.pageNo : this.pageNoT
      JfgetDistributionGoodsNumber({
        confirmStatus: index,
        ...param,
        pageNo,
        pageSize
      })
        .then(res => {
          console.log(res)
          this.totalWeight = res.totalAllWeight
          this.totalNumber = res.totalNumber
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    chexiao () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据撤销！')
        return
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据撤销！')
        return
      } else if (this.selectList[0].instockDate == '') {
        DonMessage.error('入库日期为空的不允许撤销分货！')
        return
      }
      this.$confirm('确定撤销分货吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        JfrevokeDistributionGoods({
          distributionGoodsId: this.selectList[0].distributionGoodsId // 主键id
        }).then((res) => {
          this.$message.success('撤销成功')
          this.chaxun()
        }).catch((err) => {
          this.$message.error(err.message)
        })
      }).catch(() => { })
    },
    addFenHuo () {
      let obj = {
        distributCustomerTaxId: '',
        distributNumber: '',
        lizhong: '',
        poundWeight: '',
        singletonWeight: this.fenhuoQian[0].singletonWeight,
        outWeighingMethod: this.fenhuoQian[0].outWeighingMethod
      }
      this.fenhuoHou.push(obj)
    },
    FhnumberInput (row) {
      console.log(row)
      row.lizhong = Number(row.distributNumber / 1 * row.singletonWeight / 1).toFixed(4)
    },
    HuozhuName (row) {
      row.distributCustomerName = this.HZData.filter(item => item.taxpayerNumber == row.distributCustomerTaxId)[0]
        .custerName
    },
    // 待确认查询
    JfgetDistributionGoodsLists () {
      JfgetDistributionGoodsList({
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        changeNo: this.formData.changeNo,
        oldPriCustomerTaxId: this.formData.oldPriCustomerTaxId,
        oldCustomerTaxId: this.formData.oldCustomerTaxId,
        newPriCustomerTaxId: this.formData.newPriCustomerTaxId,
        newCustomerTaxId: this.formData.newCustomerTaxId,
        productType: this.formData.productType,
        createTimeStart: this.formData.createTimeStart,
        createTimeEnd: this.formData.createTimeEnd
      })
        .then(res => {
          console.log(res)
          this.tableData = res.list
          this.total = res.total
          this.JfgetDistributionGoodsNumbers('0')
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    selectGoods (selection) {
      this.selectListId = []
      this.selectList = selection
      let arry = []
      selection.forEach((item) => {
        arry.push(item.distributionGoodsId) // id数组
        arry = Array.from(new Set(arry)) // 去重
      })
      console.log(arry)
      this.selectListId = arry.join(',') // 获取全部货物id
    },
    // 点击进仓按钮
    QRjincang () {
      if (this.xuanzhongArr.length == 0) {
        this.xuanzhongArr = this.tableData[0]
      }
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行进仓操作！')
      } else {
        this.addLoad = false
        this.checked = false
        this.rukuFee = false
        this.xiugaiFormData.distributionInNo = ''
        this.$nextTick(() => {
          this.$refs.xiugaiFormData.clearValidate()
        })
        this.getQueryCusterData()
        this.arrivalMethod()
        let arr = []
        this.selectList.forEach(item => {
          let obj = {}
          obj.distributionGoodsId = item.distributionGoodsId
          arr.push(obj)
        })
        getConfirmGoodsFeeList({
          changeList: arr
        }).then(res => {
          console.log(res)
          if (res.length != 0) {
            this.rukuFee = true
            this.checked = true
            this.dialogVisiblejincang = true
            this.tableDataQR = res
          }
        })
          .catch(error => {
            if (error.code == 1) {
              this.rukuFee = false
              this.checked = false
              this.dialogVisiblejincang = true
            } else {
              this.$message.error(error.message)
            }
          })
      }
    },
    // 进仓确认结算客户
    changeKH () { },
    // 进仓确认到货方式
    changeDH () { },
    // 进仓保存
    jincangQR () {
      this.addLoad = true
      this.$refs.xiugaiFormData.validate((valid) => {
        if (valid) {
          let unitPrice = this.tableDataQR.some(item => item.unitPrice == '-')
          let feeAmount = this.tableDataQR.some(item => item.feeAmount == '-')
          // console.log(this.tableDataQR.some(item => item.unitPrice == ''), this.tableDataQR.some(item => item.feeAmount == ''))
          // return
          console.log(this.checked && (unitPrice || feeAmount))
          if (this.checked && (unitPrice || feeAmount)) {
            this.$message.error('存在单价为空的情况，无法提交')
            this.addLoad = false
          } else {
            let updateFeeCustomer
            if (this.checked) {
              updateFeeCustomer = '1'
            } else {
              updateFeeCustomer = ''
            }
            JfconfirmDistributionGoods({
              distributionGoodsIds: this.selectListId,
              distributionInNo: this.xiugaiFormData.distributionInNo,
              updateFeeCustomer,
              changeList: this.tableDataQR
            })
              .then((res) => {
                DonMessage.success('操作成功!')
                this.addLoad = false
                this.dialogVisiblejincang = false
                this.chaxun()
              })
              .catch((err) => {
                this.addLoad = false

                DonMessage.error(err.message)
              })
          }
        } else {
          this.addLoad = false
        }
      })
    },
    handleClicktab (tab, event) {
      console.log(tab, event)
      if (tab.$data.index == '0') {
        // this.JfgetDistributionGoodsLists()
        this.chongzhi()
      } else {
        // this.JfgetDistributionedGoodsLists()
        this.chongzhiT()
      }
      this.getHight()
    },
    chaxun () {
      this.JfgetDistributionGoodsLists()
      this.getVirtualBalingList()
    },
    chongzhi () {
      this.formData.changeNo = ''
      this.formData.oldPriCustomerTaxId = ''
      this.formData.oldCustomerTaxId = ''
      this.formData.newPriCustomerTaxId = ''
      this.formData.newCustomerTaxId = ''
      this.formData.productType = ''
      this.formData.createTimeStart = ''
      this.formData.createTimeEnd = ''
      this.JfgetDistributionGoodsLists()
      this.getVirtualBalingList()
      this.JfgetDistributionGoodsNumbers('0')
    },
    daochu () {
      exportExcel(
        this.global.wmsStockName + '/distributionGoods/exportDistributionGoodsList', {
          ...this.formData,
          ...this.pageInfo
        },
        '分货确认待确认表'
      )
    },
    ercifenhuo () {
      if (this.selectList.length == 0) {
        this.$message({
          message: '请选择一条数据',
          type: 'error'
        })
        return
      } else if (this.selectList.length > 1) {
        this.$message({
          message: '请选择一条数据',
          type: 'error'
        })
        return
      }
      this.ecfhVisible = true
      this.fenhuoQian = []
      this.fenhuoHou = []

      this.fenhuoQian.push(this.selectList[0])
      this.addFenHuo()
      getWeighingMethodList({
        productType: this.fenhuoQian[0].productType
      })
        .then(res => {
          console.log(res)
          this.$set(this.fenhuoQian[0], 'outWeighingMethod', res[0].outWeighingMethod)
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    closeDialogEcfh () {
      this.ecfhVisible = false
    },
    // 二次分货
    erciFenhuoSave () {
      let allNumber = this.fenhuoHou.reduce((pre, cur) => {
        return pre / 1 + cur.distributNumber / 1
      }, 0)
      if (allNumber > this.fenhuoQian[0].number) {
        this.$message({
          message: '分货后件数不可大于分货前件数',
          type: 'error'
        })
        return
      } else if (this.fenhuoHou.length == 0) {
        this.$message({
          message: '分货后信息不能为空',
          type: 'error'
        })
        return
      }
      for (let i = 0; i < this.fenhuoHou.length; i++) {
        if (this.fenhuoHou[i].distributCustomerTaxId == '') {
          this.$message({
            message: '请选择二级货主',
            type: 'error'
          })
          return
        } else if (this.fenhuoHou[i].distributNumber == '') {
          this.$message({
            message: '请填写分货件数',
            type: 'error'
          })
          return
        } else if (this.fenhuoHou[i].distributNumber == 0) {
          this.$message({
            message: '分货件数不能为0',
            type: 'error'
          })
          return
        } else if (this.fenhuoQian[0].outWeighingMethod == '2' && this.fenhuoHou[i].poundWeight == '') {
          this.$message({
            message: '请填写磅重',
            type: 'error'
          })
          return
        }
      }
      JfsecondDistributionGoods({
        distributionGoodsId: this.fenhuoQian[0].distributionGoodsId,
        distributionGoodsList: this.fenhuoHou
      })
        .then(res => {
          console.log(res)
          this.ecfhVisible = false
          this.chaxun()
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    xiugai () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        this.XGvisible = true
        this.oldcustomer = this.selectList[0].newCustomerName
        this.KHFormData.modifyAfter = ''
        this.$nextTick(() => {
          this.$refs.KHFormData.clearValidate()
        })
      }
    },
    // 修改客户
    XGQD () {
      this.addLoad = true
      this.$refs.KHFormData.validate((valid) => {
        if (valid) {
          this.KHFormData.customerName = this.HZData.filter(item => item.taxpayerNumber == this.KHFormData
            .modifyAfter)[0].custerName
          JfmodifyDistributionGoods({
            distributionGoodsId: this.selectList[0].distributionGoodsId,
            businessType: 3,
            modifyAfter: this.KHFormData.customerName,
            modifyAfterId: this.KHFormData.modifyAfter,
            modifyBeforeId: this.selectList[0].newCustomerTaxId,
            modifyBefore: this.selectList[0].newCustomerName
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.JfgetDistributionGoodsLists()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
          this.XGvisible = false
        } else {
          this.addLoad = false
        }
      })
    },
    // 已确认查询
    JfgetDistributionedGoodsLists () {
      JfgetDistributionedGoodsList({
        pageNo: this.pageNoT,
        pageSize: this.pageSizeT,
        changeNo: this.formDataTwo.changeNo,
        distributionInNo: this.formDataTwo.distributionInNo,
        oldPriCustomerTaxId: this.formDataTwo.oldPriCustomerTaxId,
        oldCustomerTaxId: this.formDataTwo.oldCustomerTaxId,
        newPriCustomerTaxId: this.formDataTwo.newPriCustomerTaxId,
        newCustomerTaxId: this.formDataTwo.newCustomerTaxId,
        productType: this.formDataTwo.productType,
        confirmTimeStart: this.formDataTwo.confirmTimeStart,
        confirmTimeEnd: this.formDataTwo.confirmTimeEnd,
        createTimeStart: this.formDataTwo.createTimeStart,
        createTimeEnd: this.formDataTwo.createTimeEnd
      })
        .then(res => {
          console.log(res)
          this.tableDataT = res.list
          this.totalT = res.total
          this.JfgetDistributionGoodsNumbers('1')
        })
        .catch(error => {
          DonMessage.error(error.message)
        })
    },
    chaxunT () {
      this.JfgetDistributionedGoodsLists()
      this.getVirtualBalingList()
    },
    chongzhiT () {
      this.formDataTwo.changeNo = ''
      this.formDataTwo.distributionInNo = ''
      this.formDataTwo.oldPriCustomerTaxId = ''
      this.formDataTwo.oldCustomerTaxId = ''
      this.formDataTwo.newPriCustomerTaxId = ''
      this.formDataTwo.newCustomerTaxId = ''
      this.formDataTwo.productType = ''
      this.formDataTwo.confirmTimeStart = ''
      this.formDataTwo.confirmTimeEnd = ''
      this.formDataTwo.createTimeStart = ''
      this.formDataTwo.createTimeEnd = ''
      this.JfgetDistributionedGoodsLists()
      this.getVirtualBalingList()
    },
    daochuT () {
      exportExcel(
        this.global.wmsStockName + '/distributionGoods/exportDistributionedGoodsList', {
          ...this.formDataTwo,
          ...this.pageInfo
        },
        '分货确认已确认表'
      )
    },
    chexiaoT () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据撤销！')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据撤销！')
      } else if (this.selectList[0].instockDate == '') {
        DonMessage.error('入库日期为空的不允许撤销！')
      } else {
        this.$confirm('是否执行撤销操作', '系统提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(res => {
          revokeConfirmDistributionGoods({
            distributionGoodsIds: this.selectList.map(item => item.distributionGoodsId).join(',')
          }).then(res => {
            this.chaxunT()
          }).catch(error => {
            this.$confirm(error.message, '系统提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消'
            }).then(() => {
              const loading = this.$loading({
                lock: true,
                text: '正在处理...'
              })
              revokeConfirmDistributionGoods({
                distributionGoodsIds: this.selectList.map(item => item.distributionGoodsId).join(','),
                delFeeJc: '1'
              }).then(res => {
                console.log()
                loading.close()
                this.$message({
                  message: '成功',
                  type: 'success'
                })
                this.chaxunT()
              }).catch(error => {
                // this.$message({
                //   showClose: true,
                //   message: error.message,
                //   type: 'error',
                // onClose() {
                loading.close()
                // }
                // })
              })
            }).catch(() => {

            })
          })
        })
          .catch(() => {

          })
      }
    },
    xiugaiT () {
      if (this.selectList.length == 0) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else if (this.selectList.length > 1) {
        DonMessage.error('请选择一条数据进行修改操作！')
      } else {
        this.XGDHvisible = true
        this.oldDH = this.selectList[0].distributionInNo
        this.$nextTick(() => {
          this.$refs.DHFormData.clearValidate()
        })
        this.DHFormData.modifyAfter = ''
      }
    },

    // 修改单号
    XGDH () {
      this.addLoad = true
      this.$refs.DHFormData.validate((valid) => {
        if (valid) {
          JfmodifyDistributionGoods({
            distributionGoodsId: this.selectListId,
            businessType: 4,
            modifyAfter: this.DHFormData.modifyAfter,
            modifyBefore: this.selectList[0].distributionInNo
          })
            .then((res) => {
              DonMessage.success('操作成功!')
              this.addLoad = false
              this.JfgetDistributionedGoodsLists()
            })
            .catch((err) => {
              DonMessage.error(err.message)
              this.addLoad = false
            })
          this.XGDHvisible = false
        } else {
          this.addLoad = false
        }
      })
    },
    NumberInput (row) {
      console.log(row)
      this.$set(row, 'unpackingWeight', (row.unpackingNumber / 1 * row.singletonWeight / 1).toFixed(4))
    },
    // 修改记录
    editRecord (index, row) {
      this.XGJLVisible = true
      JfgetStorkConfirmedlList({
        businessId: row.distributionGoodsId,
        businessType: 4
      })
        .then(res => {
          console.log(res)
          this.XGRecordData = res
        })
        .catch(err => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    // 修改记录保存
    succeXGJL () {

    },
    // 修改记录关闭
    closeXGJL () {
      this.XGJLVisible = false
    },
    handleCurrentChange (val) {
      this.pageNo = val
      this.JfgetDistributionGoodsLists()
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.JfgetDistributionGoodsLists()
    },
    handleCurrentChangeT (val) {
      this.pageNoT = val
      this.JfgetDistributionedGoodsLists()
    },
    handleSizeChangeT (val) {
      this.pageSizeT = val
      this.JfgetDistributionedGoodsLists()
    },
    // 字典-查询客户
    getRelationCustomerS () {
      getRelationCustomer({
        // groupNo: "change_status"
      })
        .then((res) => {
          // console.log(res)
          this.HZData = res
        })
        .catch((err) => {
          this.$message({
            message: err.message,
            type: 'error'
          })
        })
    },
    getHight () {
      this.$nextTick(() => {
        let h = this.$refs.searchBox.offsetHeight
        let pH = document.documentElement.clientHeight
        this.h = pH - h - 205 + 'px'
        let H = this.$refs.searchBoxT.offsetHeight
        let pHT = document.documentElement.clientHeight
        this.H = pHT - H - 205 + 'px'
      })
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnArr, '/resolveConfirm')
    this.getRelationCustomerS()
    this.JfgetDistributionGoodsLists()
    this.getVirtualBalingList()
    var _this = this
    document.onkeydown = function (e) {
      let key = window.event.keyCode
      if (key == 13) {
        if (_this.ecfhVisible == true) {
          // 二次分货确定
          _this.erciFenhuoSave()
        } else if (_this.XGvisible == true) {
          // 修改客户
          _this.XGQD()
        } else if (_this.dialogVisiblejincang == true) {
          _this.jincangQR()
        } else if (_this.activeName == 'first') {
          _this.JfgetDistributionGoodsLists()
        } else if (_this.activeName == 'second') {
          _this.JfgetDistributionedGoodsLists()
        }
      }
    }
  },
  mounted () {
    this.getHight()
  }
}

</script>

<style lang="less" scoped>
.inpBox {
  .el-form-item {
    margin-left: 10px;
    margin-bottom: 0px;
  }
}

/deep/.el-table th.star div::before {
  content: '*' !important;
  color: red !important;
}

.activeOne {
  /deep/.el-dialog--center .el-dialog__body {
    text-align: center;
  }
}

.activeTwo {
  /deep/.el-dialog--center .el-dialog__body {
    text-align: initial;
  }
}
/deep/.el-tabs__header{
  margin-bottom: 0;
}
</style>
